const SELECTOR = '.wp-block-gpchild-animation-sequence';
const DEBUG_VERSION = '2026.04.03-14';
const INSTANCE_KEY = '__gpchildAnimationSequenceInstance';

const _dbg = (message) => {
    if (typeof window !== 'undefined' && typeof window.gpchildDbg === 'function') {
        window.gpchildDbg(message);
    }
};

const toArray = (nodeList) => Array.from(nodeList || []);
const qs = (node, sel) => (node ? node.querySelector(sel) : null);
const qsa = (node, sel) => (node ? toArray(node.querySelectorAll(sel)) : []);
const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

function queryParamTruthy(name) {
    if (typeof window === 'undefined') return false;
    try {
        const params = new URLSearchParams(window.location.search || '');
        if (!params.has(name)) return false;
        const raw = String(params.get(name) || '').trim().toLowerCase();
        return raw === '' || raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
    } catch (_) {
        const re = new RegExp(`[?&]${name}(?:=([^&#]*))?(?:[&#]|$)`, 'i');
        const m = String(window.location.search || '').match(re);
        if (!m) return false;
        const raw = decodeURIComponent((m[1] || '').replace(/\+/g, ' ')).trim().toLowerCase();
        return raw === '' || raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
    }
}

function shouldEnableDebugUi() {
    return queryParamTruthy('gpchild_debug') || queryParamTruthy('d') || queryParamTruthy('debug');
}

function isIOSLike() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';
    const maxTouchPoints = navigator.maxTouchPoints || 0;
    return /iPhone|iPad|iPod/i.test(ua)
        || (/Mac/i.test(platform) && maxTouchPoints > 1);
}

function detectDebugVersion() {
    if (typeof document === 'undefined') return DEBUG_VERSION;
    const root = document.querySelector(SELECTOR);
    if (!root) return DEBUG_VERSION;
    return root.getAttribute('data-gpchild-debug-version') || DEBUG_VERSION;
}

function ensureDebugUi() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const isLiteDebug = queryParamTruthy('d') && !queryParamTruthy('debug') && !queryParamTruthy('gpchild_debug');

    if (!window.gpchildDbgLines) window.gpchildDbgLines = [];

    let wrap = document.getElementById('gpchild-dbg');
    if (!wrap) {
        wrap = document.createElement('div');
        wrap.id = 'gpchild-dbg';
        wrap.style.cssText = 'position:fixed;top:calc(env(safe-area-inset-top,0px) + 72px);right:6px;left:auto;bottom:auto;background:rgba(0,0,0,0.92);color:#0f0;font:11px/1.6 monospace;padding:8px 10px;z-index:999999;max-width:min(92vw,520px);overflow:hidden;-webkit-overflow-scrolling:touch;pointer-events:auto;word-break:break-all;text-align:left;border-radius:6px;';

        const header = document.createElement('div');
        header.style.cssText = 'position:sticky;top:0;z-index:1;display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:6px;padding:2px 0;background:rgba(0,0,0,0.92);';
        const title = document.createElement('strong');
        title.style.color = '#8ff';
        title.textContent = 'gpchild debug';
        const copy = document.createElement('button');
        copy.type = 'button';
        copy.id = 'gpchild-dbg-copy';
        copy.textContent = 'ログをコピー';
        copy.style.cssText = 'border:1px solid #7ec8ff;background:#1d2a35;color:#d6f1ff;border-radius:4px;padding:3px 8px;cursor:pointer;font:11px/1.4 monospace;';
        const save = document.createElement('button');
        save.type = 'button';
        save.id = 'gpchild-dbg-save';
        save.textContent = 'TXT保存';
        save.style.cssText = 'border:1px solid #7ec8ff;background:#1d2a35;color:#d6f1ff;border-radius:4px;padding:3px 8px;cursor:pointer;font:11px/1.4 monospace;';
        const ver = document.createElement('span');
        ver.id = 'gpchild-dbg-ver';
        ver.textContent = 'ver: ' + detectDebugVersion();
        ver.style.cssText = 'display:inline-flex;align-items:center;border:1px solid #315067;background:#0f1b24;color:#8fd3ff;border-radius:4px;padding:3px 8px;font:11px/1.4 monospace;';
        const actions = document.createElement('span');
        actions.style.cssText = 'display:inline-flex;gap:6px;';
        actions.appendChild(ver);
        actions.appendChild(copy);
        actions.appendChild(save);
        header.appendChild(title);
        header.appendChild(actions);

        const log = document.createElement('pre');
        log.id = 'gpchild-dbg-log';
        log.style.cssText = `display:${isLiteDebug ? 'none' : 'block'};margin:0;white-space:pre-wrap;text-align:left;`;

        wrap.appendChild(header);
        wrap.appendChild(log);
        document.body.appendChild(wrap);
    }

    const existingLogEl = document.getElementById('gpchild-dbg-log');
    if (existingLogEl) {
        existingLogEl.style.display = isLiteDebug ? 'none' : 'block';
    }

    window.gpchildDbg = function (m) {
        const logEl = document.getElementById('gpchild-dbg-log');
        if (!logEl) return;
        const d = new Date();
        const ts = d.getMinutes() + ':' + ('0' + d.getSeconds()).slice(-2) + '.' + ('00' + d.getMilliseconds()).slice(-3);
        const line = '[' + ts + '] ' + String(m);
        window.gpchildDbgLines.push(line);
        logEl.textContent = window.gpchildDbgLines.join('\n');
        const wrapEl = document.getElementById('gpchild-dbg');
        if (wrapEl) wrapEl.scrollTop = wrapEl.scrollHeight;
    };

    window.gpchildDbgCopyAll = async function () {
        const text = (window.gpchildDbgLines || []).join('\n');
        if (!text) return false;
        try {
            await navigator.clipboard.writeText(text);
            window.gpchildDbg('✅ ログをクリップボードへコピーしました');
            return true;
        } catch (e) {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            let ok = false;
            try { ok = document.execCommand('copy'); } catch (_) {}
            document.body.removeChild(ta);
            window.gpchildDbg(ok ? '✅ ログをコピーしました(fallback)' : '❌ コピー失敗');
            return ok;
        }
    };

    window.gpchildDbgSaveAll = function () {
        const text = (window.gpchildDbgLines || []).join('\n');
        if (!text) return false;
        const now = new Date();
        const pad = (n) => (`0${n}`).slice(-2);
        const ts = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        const filename = `gpchild-debug-${ts}.txt`;
        try {
            const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 1000);
            window.gpchildDbg(`✅ ログを保存しました: ${filename}`);
            return true;
        } catch (e) {
            window.gpchildDbg(`❌ 保存失敗: ${e && e.message ? e.message : 'unknown'}`);
            return false;
        }
    };

    const btn = document.getElementById('gpchild-dbg-copy');
    const saveBtn = document.getElementById('gpchild-dbg-save');
    let verEl = document.getElementById('gpchild-dbg-ver');
    if (!verEl) {
        const actionsWrap = btn && btn.parentElement ? btn.parentElement : null;
        if (actionsWrap) {
            verEl = document.createElement('span');
            verEl.id = 'gpchild-dbg-ver';
            verEl.style.cssText = 'display:inline-flex;align-items:center;border:1px solid #315067;background:#0f1b24;color:#8fd3ff;border-radius:4px;padding:3px 8px;font:11px/1.4 monospace;';
            actionsWrap.insertBefore(verEl, btn);
        }
    }
    if (verEl) {
        verEl.textContent = 'ver: ' + detectDebugVersion();
    }
    if (btn && !btn.getAttribute('data-gpchild-bound')) {
        btn.setAttribute('data-gpchild-bound', '1');
        btn.addEventListener('click', () => window.gpchildDbgCopyAll());
    }
    if (saveBtn && !saveBtn.getAttribute('data-gpchild-bound')) {
        saveBtn.setAttribute('data-gpchild-bound', '1');
        saveBtn.addEventListener('click', () => window.gpchildDbgSaveAll());
    }

    window.gpchildDbg(
        'デバッグUI初期化: d='
        + queryParamTruthy('d')
        + ', debug='
        + queryParamTruthy('debug')
        + ', gpchild_debug='
        + queryParamTruthy('gpchild_debug')
    );
    window.gpchildDbg('version=' + detectDebugVersion());
    window.gpchildDbg('UA=' + navigator.userAgent);
}

function cap(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

function rectText(rect) {
    if (!rect) return 'n/a';
    return `x=${Math.round(rect.left)},y=${Math.round(rect.top)},w=${Math.round(rect.width)},h=${Math.round(rect.height)}`;
}

function styleText(el, keys) {
    if (!el) return 'n/a';
    const cs = getComputedStyle(el);
    return keys.map((k) => `${k}=${cs.getPropertyValue(k).trim()}`).join(' ');
}

function debugPanelLayout(panel, label) {
    if (!panel) return;
    const body = qs(panel, '.gpchild-animation-panel__body');
    const inner = qs(panel, '.gpchild-animation-panel__inner');
    const panelRect = panel.getBoundingClientRect();
    const bodyRect = body ? body.getBoundingClientRect() : null;
    const innerRect = inner ? inner.getBoundingClientRect() : null;
    _dbg(
        `${label} class=${panel.className} hidden=${panel.hidden} ` +
        `panel(${rectText(panelRect)}) body(${rectText(bodyRect)}) inner(${rectText(innerRect)})`
    );
    _dbg(
        `${label} style.panel ${styleText(panel, ['left', 'right', 'top', 'bottom', 'transform', 'display', 'justify-content', 'text-align'])}`
    );
    _dbg(
        `${label} style.body ${styleText(body, ['display', 'width', 'max-width', 'overflow'])}`
    );
    _dbg(
        `${label} style.inner ${styleText(inner, ['writing-mode', 'max-inline-size', 'max-block-size', 'overflow-wrap', 'word-break'])}`
    );
}

function overflowAmounts(containerRect, targetRect) {
    if (!containerRect || !targetRect) return 'n/a';
    const overLeft = Math.max(0, Math.round(containerRect.left - targetRect.left));
    const overRight = Math.max(0, Math.round(targetRect.right - containerRect.right));
    const overTop = Math.max(0, Math.round(containerRect.top - targetRect.top));
    const overBottom = Math.max(0, Math.round(targetRect.bottom - containerRect.bottom));
    return `L${overLeft}/R${overRight}/T${overTop}/B${overBottom}`;
}

function debugSequenceOverflow(root, label, singlePanel = null) {
    if (!root) return;
    const panelsInner = qs(root, '.gpchild-animation-sequence__panels-inner');
    if (!panelsInner) {
        _dbg(`${label} overflow: panels-inner not found`);
        return;
    }
    const containerRect = panelsInner.getBoundingClientRect();
    _dbg(`${label} overflow container=${rectText(containerRect)}`);

    const panels = singlePanel ? [singlePanel] : qsa(root, '.wp-block-gpchild-animation-panel');
    panels.forEach((panel, idx) => {
        const body = qs(panel, '.gpchild-animation-panel__body');
        const inner = qs(panel, '.gpchild-animation-panel__inner');
        const panelRect = panel.getBoundingClientRect();
        const bodyRect = body ? body.getBoundingClientRect() : null;
        const innerRect = inner ? inner.getBoundingClientRect() : null;
        const bodyScroll = body ? `sw=${body.scrollWidth},cw=${body.clientWidth}` : 'n/a';
        const innerScroll = inner ? `sw=${inner.scrollWidth},cw=${inner.clientWidth}` : 'n/a';
        _dbg(
            `${label} overflow panel[${idx}] hidden=${panel.hidden} class=${panel.className} ` +
            `panel=${rectText(panelRect)} ov=${overflowAmounts(containerRect, panelRect)} ` +
            `body=${rectText(bodyRect)} ov=${overflowAmounts(containerRect, bodyRect)} bodyScroll(${bodyScroll}) ` +
            `inner=${rectText(innerRect)} ov=${overflowAmounts(containerRect, innerRect)} innerScroll(${innerScroll})`
        );
    });
}

function readNumber(el, key, fallback) {
    const value = Number(el.getAttribute(`data-gpchild-${key}`));
    return Number.isFinite(value) ? value : fallback;
}

function readString(el, key, fallback) {
    const value = el.getAttribute(`data-gpchild-${key}`);
    return value ? value : fallback;
}

function camelToKebab(value) {
    return String(value)
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase();
}

function getAnimationConfig(el, prefix) {
    const base = camelToKebab(prefix);
    return {
        type: readString(el, `${base}-type`, 'none'),
        opacityFrom: readNumber(el, `${base}-opacity-from`, 0),
        opacityTo: readNumber(el, `${base}-opacity-to`, 1),
        distancePx: readNumber(el, `${base}-distance-px`, 12),
        blurFromPx: readNumber(el, `${base}-blur-from-px`, 0),
        blurToPx: readNumber(el, `${base}-blur-to-px`, 0),
        direction: readString(el, `${base}-direction`, 'up'),
        scaleFrom: readNumber(el, `${base}-scale-from`, 0.9),
        scaleTo: readNumber(el, `${base}-scale-to`, 1),
        origin: readString(el, `${base}-origin`, 'center'),
        insetFrom: readNumber(el, `${base}-inset-from`, 20),
        insetTo: readNumber(el, `${base}-inset-to`, 0),
        durationMs: readNumber(el, `${base}-duration-ms`, 250),
        delayMs: readNumber(el, `${base}-delay-ms`, 0),
        waitAfterMs: readNumber(el, `${base}-wait-after-ms`, 0),
        easing: readString(el, `${base}-easing`, 'ease'),
    };
}

function reverseConfig(cfg) {
    return {
        ...cfg,
        opacityFrom: cfg.opacityTo,
        opacityTo: cfg.opacityFrom,
        blurFromPx: cfg.blurToPx,
        blurToPx: cfg.blurFromPx,
        scaleFrom: cfg.scaleTo,
        scaleTo: cfg.scaleFrom,
        insetFrom: cfg.insetTo,
        insetTo: cfg.insetFrom,
    };
}

function instantSnap(cfg) {
    return { ...cfg, durationMs: 0, delayMs: 0, waitAfterMs: 0 };
}

function snapToFromState(cfg) {
    return instantSnap({
        ...cfg,
        opacityTo: cfg.opacityFrom,
        blurToPx: cfg.blurFromPx,
        scaleTo: cfg.scaleFrom,
        insetTo: cfg.insetFrom,
    });
}

function getSlideAxis(direction, distance) {
    if (direction === 'up') return `translateY(${distance}px)`;
    if (direction === 'down') return `translateY(${-distance}px)`;
    if (direction === 'left') return `translateX(${distance}px)`;
    return `translateX(${-distance}px)`;
}

function applyFinalKeyframe(el, kf) {
    if (!el || !kf) return;
    for (var prop in kf) {
        try { el.style[prop] = kf[prop]; } catch (_) {}
    }
}

async function runAnim(el, cfg) {
    if (!el || cfg.type === 'none') return;
    _dbg('runAnim: type=' + cfg.type + ' dur=' + cfg.durationMs + ' hasAnimate=' + (typeof el.animate === 'function'));
    const delayMs = cap(cfg.delayMs, 0, 10000);
    const durationMs = cap(cfg.durationMs, 0, 10000);
    const waitAfterMs = cap(cfg.waitAfterMs, 0, 10000);
    const opts = { duration: durationMs, delay: delayMs, easing: cfg.easing, fill: 'forwards' };
    let keyframes = [];
    const opacityFrom = cap(cfg.opacityFrom, 0, 1);
    const opacityTo = cap(cfg.opacityTo, 0, 1);

    if (cfg.type === 'fade') {
        keyframes = [{ opacity: opacityFrom }, { opacity: opacityTo }];
    } else if (cfg.type === 'slide') {
        keyframes = [
            { opacity: opacityFrom, transform: getSlideAxis(cfg.direction, cfg.distancePx) },
            { opacity: opacityTo, transform: 'translate(0, 0)' },
        ];
    } else if (cfg.type === 'zoom') {
        el.style.transformOrigin = cfg.origin;
        keyframes = [
            { opacity: opacityFrom, transform: `scale(${cfg.scaleFrom})` },
            { opacity: opacityTo, transform: `scale(${cfg.scaleTo})` },
        ];
    } else if (cfg.type === 'blur') {
        const blurFrom = cap(cfg.blurFromPx, 0, 80);
        const blurTo = cap(cfg.blurToPx, 0, 80);
        let opacityToForBlur = opacityTo;

        if (blurTo > blurFrom && Math.abs(opacityFrom - opacityToForBlur) < 0.001) {
            opacityToForBlur = 0;
        }

        keyframes = [
            { opacity: opacityFrom, filter: `blur(${blurFrom}px)` },
            { opacity: opacityToForBlur, filter: `blur(${blurTo}px)` },
        ];
    } else if (cfg.type === 'clip') {
        const from = cap(cfg.insetFrom, 0, 100);
        const to = cap(cfg.insetTo, 0, 100);
        let clipFrom = `inset(${from}% 0 0 0)`;
        let clipTo = `inset(${to}% 0 0 0)`;
        if (cfg.direction === 'down') {
            clipFrom = `inset(0 0 ${from}% 0)`;
            clipTo = `inset(0 0 ${to}% 0)`;
        } else if (cfg.direction === 'left') {
            clipFrom = `inset(0 ${from}% 0 0)`;
            clipTo = `inset(0 ${to}% 0 0)`;
        } else if (cfg.direction === 'right') {
            clipFrom = `inset(0 0 0 ${from}%)`;
            clipTo = `inset(0 0 0 ${to}%)`;
        }
        keyframes = [
            { opacity: opacityFrom, clipPath: clipFrom },
            { opacity: opacityTo, clipPath: clipTo },
        ];
    }
    if (!keyframes.length) return;

    const finalKf = keyframes[keyframes.length - 1];

    if (typeof el.animate === 'function') {
        const anim = el.animate(keyframes, opts);
        try {
            // iOS WebKit で finished が解決しないケースに備えたタイムアウト付き待機
            await Promise.race([
                anim.finished,
                wait(delayMs + durationMs + 2000),
            ]);
        } catch (e) {
            // Animation cancelled or rejected — fall through to inline style application
        }
        try { anim.cancel(); } catch (_) {}
    } else {
        await wait(delayMs + durationMs);
    }

    // Web Animations API の状態に依存せず、最終キーフレームの値を
    // 必ずインラインスタイルとして書き込む（iOS Safari 対策の要）
    applyFinalKeyframe(el, finalKf);

    if (waitAfterMs > 0) {
        await wait(waitAfterMs);
    }
}

/** 表示倍率を掛けるタイポ要素（元の computed font-size（px）× scale） */
const TYPO_SELECTOR = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'li',
    '.wp-block-paragraph',
    '.wp-block-heading',
    '.wp-block-quote',
    '.wp-block-pullquote',
    '.wp-block-verse',
    '.wp-block-preformatted',
    '.wp-block-code',
    '.wp-block-post-title',
    '.wp-block-site-title',
    'th',
    'td',
    'figcaption',
    '.wp-block-button__link',
    'cite',
    'span[style*="font-size"]',
].join(',');

function debounce(fn, ms) {
    let t;
    return function debounced(...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), ms);
    };
}

function throttle(fn, ms) {
    let last = 0;
    let timer;
    return function throttled(...args) {
        const now = Date.now();
        const remaining = ms - (now - last);
        clearTimeout(timer);
        if (remaining <= 0) {
            last = now;
            fn.apply(this, args);
        } else {
            timer = setTimeout(() => {
                last = Date.now();
                fn.apply(this, args);
            }, remaining);
        }
    };
}

function depthWithin(el, ancestor) {
    let d = 0;
    let n = el;
    while (n && n !== ancestor) {
        d += 1;
        n = n.parentElement;
    }
    return d;
}

// _variables.scss / _animation-sequence.scss の $bp-md(768), $bp-lg(1024) と一致させること
const BP_MD = 768;
const BP_LG = 1024;

/**
 * data 属性の数値を倍率にする。
 * エディタ保存値はパーセント整数 10–200（例: 100 → 1）。
 * 既存 HTML や React の style 由来で「1」「0.8」のように倍率そのものが入っている場合も解釈する。
 */
function scaleFromPanelDataAttributeNumber(n) {
    if (!Number.isFinite(n) || n <= 0) return null;
    if (n >= 10) {
        return cap(n / 100, 0.05, 4);
    }
    return cap(n, 0.05, 4);
}

function parseTypographyScaleFromPanel(panel) {
    const w = typeof window !== 'undefined' ? window.innerWidth : BP_LG + 1;
    const attr =
        w >= BP_LG + 1
            ? 'data-gpchild-panel-scale-pc'
            : w >= BP_MD
              ? 'data-gpchild-panel-scale-tablet'
              : 'data-gpchild-panel-scale-mobile';
    const fromAttr = scaleFromPanelDataAttributeNumber(parseFloat(panel.getAttribute(attr)));
    if (fromAttr != null) {
        return fromAttr;
    }
    const cs = getComputedStyle(panel);
    const rawVar =
        w >= BP_LG + 1
            ? cs.getPropertyValue('--gpchild-panel-scale-pc').trim()
            : w >= BP_MD
              ? cs.getPropertyValue('--gpchild-panel-scale-tablet').trim()
              : cs.getPropertyValue('--gpchild-panel-scale-mobile').trim();
    const n = parseFloat(rawVar);
    if (!Number.isFinite(n) || n <= 0) return 1;
    return cap(n, 0.05, 4);
}

function isUnityTypographyScale(scale) {
    return Math.abs(scale - 1) < 0.001;
}

function parseMinFontPxFromPanel(panel) {
    const v = parseFloat(panel.getAttribute('data-gpchild-min-font-px'));
    if (!Number.isFinite(v) || v <= 0) return 12;
    return cap(v, 8, 64);
}

function getTypoElements(inner) {
    return qsa(inner, TYPO_SELECTOR);
}

/**
 * 計測した元の px（各要素ごと）× scale を基準にし、最小フォント制限は「全体の底上げ」で効かせる（各要素に同じ下限を当てない）
 *
 * 以前は毎回すべての font-size を消していたため、スケール 100% でもブロック本来のインライン/クラス由来の大きさが失われ、
 * ベースサイズだけに見えていた。スクリプトが付与したものだけ戻す。
 */
function revertScriptedPanelTypography(inner) {
    getTypoElements(inner).forEach((el) => {
        if (el.getAttribute('data-gpchild-js-typo') === '1') {
            const origInline = el.getAttribute('data-gpchild-orig-inline-font-size');
            if (origInline && origInline !== '') {
                // 元が inline 指定だった場合は復元する（再計測で 17px 等に潰れるのを防ぐ）
                el.style.setProperty('font-size', origInline);
            } else {
                el.style.removeProperty('font-size');
            }
            el.removeAttribute('data-gpchild-js-typo');
            el.removeAttribute('data-gpchild-orig-font-px');
            return;
        }
        el.removeAttribute('data-gpchild-orig-font-px');
    });
}

/** theme.json / ブロックの S M L XL 等（has-small-font-size など） */
const WP_PRESET_FONT_SIZE_CLASS_RE = /^has-.+-font-size$/;

function elementHasWpFontSizePresetClass(el) {
    if (!el.classList) return false;
    for (let i = 0; i < el.classList.length; i += 1) {
        if (WP_PRESET_FONT_SIZE_CLASS_RE.test(el.classList[i])) return true;
    }
    return false;
}

function elementHasInlineFontSizeDeclaration(el) {
    const raw = el.getAttribute('style');
    return raw != null && /font-size\s*:/i.test(raw);
}

/**
 * カラム・グループ等のラッパーにだけプリセットが付き、子の p は継承のはずがテーマの p { font-size } で潰されている場合に、
 * 最も近い祖先のプリセット解決後サイズを採用する（兄弟段落で別カラムなら別サイズのまま）。
 */
function nearestWpPresetWrapperFontPx(el, inner) {
    let n = el.parentElement;
    while (n && n !== inner) {
        if (elementHasWpFontSizePresetClass(n)) {
            const px = parseFloat(getComputedStyle(n).fontSize);
            if (Number.isFinite(px) && px > 0) return px;
        }
        n = n.parentElement;
    }
    return null;
}

/**
 * 各タイポ要素ごとに基準 px を決める。要素自身のプリセット／インラインは computed をそのまま信頼。
 * 継承がテーマに潰されているときだけ、内側から最も近い has-*-font-size 祖先の computed を使う。
 */
function measureTypographyOrigPx(el, inner) {
    const self = parseFloat(getComputedStyle(el).fontSize);
    if (!Number.isFinite(self) || self <= 0) return null;

    if (elementHasWpFontSizePresetClass(el) || elementHasInlineFontSizeDeclaration(el)) {
        return cap(self, 1, 512);
    }

    const fromWrapper = nearestWpPresetWrapperFontPx(el, inner);
    if (fromWrapper != null && fromWrapper > self * 1.01) {
        return cap(fromWrapper, 1, 512);
    }

    return cap(self, 1, 512);
}

function collectTypographyEntries(inner, elements) {
    const entries = [];
    const sorted = elements.slice().sort((a, b) => depthWithin(b, inner) - depthWithin(a, inner));
    sorted.forEach((el) => {
        let origPx = el.getAttribute('data-gpchild-orig-font-px');
        if (origPx == null || origPx === '') {
            // 元が inline 指定だった場合、後で revert するため退避しておく
            if (!el.hasAttribute('data-gpchild-orig-inline-font-size')) {
                const inline = el.style && typeof el.style.getPropertyValue === 'function'
                    ? el.style.getPropertyValue('font-size')
                    : '';
                if (inline && inline !== '') {
                    el.setAttribute('data-gpchild-orig-inline-font-size', inline);
                }
            }
            const px = measureTypographyOrigPx(el, inner);
            if (px == null) return;
            el.setAttribute('data-gpchild-orig-font-px', String(px));
            origPx = String(px);
        }
        const o = parseFloat(origPx);
        if (!Number.isFinite(o) || o <= 0) return;
        entries.push({ el, o });
    });
    return entries;
}

function computeMinFontUplift(entries, scale, minPx) {
    if (!entries.length || minPx <= 0) return 0;
    let minScaled = Infinity;
    entries.forEach(({ o }) => {
        const sc = o * scale;
        if (sc < minScaled) minScaled = sc;
    });
    if (!Number.isFinite(minScaled) || minScaled >= minPx) return 0;
    return minPx - minScaled;
}

function applyPanelTypographyScale(panel) {
    const inner = qs(panel, '.gpchild-animation-panel__inner');
    if (!inner) return;

    revertScriptedPanelTypography(inner);

    const scale = parseTypographyScaleFromPanel(panel);
    const minPx = parseMinFontPxFromPanel(panel);
    const elements = getTypoElements(inner);

    if (isUnityTypographyScale(scale)) {
        return;
    }

    const entries = collectTypographyEntries(inner, elements);
    if (!entries.length) return;

    const uplift = computeMinFontUplift(entries, scale, minPx);
    entries.forEach(({ el, o }) => {
        const next = Math.round((o * scale + uplift) * 1000) / 1000;
        el.style.setProperty('font-size', `${next}px`, 'important');
        el.setAttribute('data-gpchild-js-typo', '1');
    });
}

function setupPanelTypographyScaling(root) {
    const panels = qsa(root, '.wp-block-gpchild-animation-panel');
    const run = () => {
        panels.forEach(applyPanelTypographyScale);
        panels.forEach(constrainVerticalWritingPanel);
        debugSequenceOverflow(root, 'resize-run');
    };
    const throttledRun = throttle(run, 50);
    window.addEventListener('resize', throttledRun);
    if (document.fonts && typeof document.fonts.ready !== 'undefined') {
        document.fonts.ready.then(run);
    }
    return () => {
        window.removeEventListener('resize', throttledRun);
    };
}

function constrainVerticalWritingPanel(panel) {
    const inner = qs(panel, '.gpchild-animation-panel__inner');
    const body = qs(panel, '.gpchild-animation-panel__body');
    if (!inner || !body) return;

    const w = typeof window !== 'undefined' ? window.innerWidth : BP_LG + 1;
    const attr =
        w >= BP_LG + 1
            ? 'data-gpchild-vertical-writing-pc'
            : w >= BP_MD
              ? 'data-gpchild-vertical-writing-tablet'
              : 'data-gpchild-vertical-writing-mobile';
    const active = panel.getAttribute(attr) === '1';
    _dbg(`vw: active=${active} attr=${attr}`);

    if (!active) {
        inner.style.removeProperty('max-height');
        inner.style.removeProperty('max-width');
        inner.style.removeProperty('overflow-wrap');
        inner.style.removeProperty('word-break');
        body.style.removeProperty('max-width');
        body.style.removeProperty('width');
        body.style.removeProperty('min-width');
        inner.removeAttribute('data-gpchild-vw-constrained');
        _dbg('vw: disabled -> cleared constraints');
        return;
    }

    const seq = panel.closest('.wp-block-gpchild-animation-sequence');
    const panelsInner = seq ? qs(seq, '.gpchild-animation-sequence__panels-inner') : null;
    const containerRect = panelsInner ? panelsInner.getBoundingClientRect() : null;
    const containerW = containerRect ? Math.max(0, Math.floor(containerRect.width)) : 0;
    const containerH = containerRect ? Math.max(0, Math.floor(containerRect.height)) : 0;

    // Android 等では縦書き要素の上下オーバーを防ぐため、従来の max-size 制約を有効化。
    // iOS は描画落ち回避のため max-size 固定を避ける。
    if (!isIOSLike() && containerW > 0 && containerH > 0) {
        inner.style.setProperty('max-height', `${containerH}px`, 'important');
        inner.style.setProperty('max-width', `${containerW}px`, 'important');
        body.style.setProperty('max-width', `${containerW}px`, 'important');
        body.style.removeProperty('width');
        body.style.removeProperty('min-width');
        _dbg(`vw: non-ios max-size applied w=${containerW} h=${containerH}`);
    } else {
        inner.style.removeProperty('max-height');
        inner.style.removeProperty('max-width');
        body.style.removeProperty('max-width');
    }

    inner.style.setProperty('overflow-wrap', 'anywhere', 'important');
    inner.style.setProperty('word-break', 'break-word', 'important');

    if (isIOSLike()) {
        // iOS の縦書きで body 幅が 0 になる不具合対策:
        // inner の実測幅を body に明示して、右ズレ/見切れを防ぐ。
        const innerRect = inner.getBoundingClientRect();
        const measuredWidth = Math.max(0, Math.ceil(innerRect.width));
        if (measuredWidth > 0) {
            body.style.setProperty('width', `${measuredWidth}px`, 'important');
            body.style.setProperty('min-width', `${measuredWidth}px`, 'important');
            _dbg(`vw: ios body width fixed=${measuredWidth}px`);
        } else {
            body.style.removeProperty('width');
            body.style.removeProperty('min-width');
            _dbg('vw: ios body width fix skipped (measured=0)');
        }
    }
    inner.setAttribute('data-gpchild-vw-constrained', '1');
    _dbg('vw: enabled -> wrap constraints applied');
    debugPanelLayout(panel, 'vw-after');
}

function showPanel(panel, root = null) {
    _dbg('showPanel: hidden解除, offsetHeight強制');
    debugSequenceOverflow(root, 'show-enter-before', panel);
    panel.hidden = false;
    panel.classList.add('is-active');
    void panel.offsetHeight;
    debugPanelLayout(panel, 'show-before');
    applyPanelTypographyScale(panel);
    constrainVerticalWritingPanel(panel);
    debugPanelLayout(panel, 'show-after');
    debugSequenceOverflow(root, 'show-enter-after', panel);
    _dbg('showPanel完了: offsetH=' + panel.offsetHeight + ' offsetW=' + panel.offsetWidth);
}

function hidePanel(panel) {
    panel.hidden = true;
    panel.classList.remove('is-active');
}

async function runPanel(root, panels, state, index) {
    const panel = panels[index];
    _dbg(`runPanel start index=${index}`);
    showPanel(panel, root);

    const panelEnter = getAnimationConfig(panel, 'panelEnter');
    const panelExitRaw = getAnimationConfig(panel, 'panelExit');
    const panelAnimEnabled = true;
    const panelExitEnabled = panel.getAttribute('data-gpchild-panel-exit-enabled') === '1';
    const panelEnterEnabled = panel.getAttribute('data-gpchild-panel-enter-enabled') === '1';
    const panelUseSeparateExitAttr = panel.getAttribute('data-gpchild-panel-use-separate-exit') === '1';
    // EnterがOFFなら、Exitは必ず別Exitとして扱う（Enter逆再生は無効）
    const effectiveUseSeparateExit = panelUseSeparateExitAttr || !panelEnterEnabled;
    const panelExit = effectiveUseSeparateExit ? panelExitRaw : reverseConfig(panelEnter);

    const bodyItems = qsa(panel, '.gpchild-animation-panel__inner > *');
    const itemEnter = getAnimationConfig(panel, 'itemEnter');
    const itemExitRaw = getAnimationConfig(panel, 'itemExit');
    const itemAnimEnabled = true;
    const itemEnterEnabled = panel.getAttribute('data-gpchild-item-enter-enabled') === '1';
    const itemExitEnabled = panel.getAttribute('data-gpchild-item-exit-enabled') === '1';
    const itemExit = panel.getAttribute('data-gpchild-item-use-separate-exit') === '1' ? itemExitRaw : reverseConfig(itemEnter);
    const itemProcessOrder = panel.getAttribute('data-gpchild-item-process-order') || 'sequential';

    // 初期化はサイクル先頭で1回だけ（パネルEnter直前）
    if (panelAnimEnabled && panelEnterEnabled) {
        await runAnim(panel, snapToFromState(panelEnter));
    } else if (panelAnimEnabled && !panelEnterEnabled && panelExitEnabled) {
        await runAnim(panel, snapToFromState(panelExit));
    }
    if (itemAnimEnabled) {
        const itemStart = itemEnterEnabled
            ? snapToFromState(itemEnter)
            : itemExitEnabled
              ? snapToFromState(itemExit)
              : null;
        if (itemStart) {
            for (const item of bodyItems) {
                if (!state.enabled) return;
                await runAnim(item, itemStart);
            }
        }
    }

    if (panelAnimEnabled && panelEnterEnabled) {
        await runAnim(panel, panelEnter);
    }

    if (itemProcessOrder === 'per-block') {
        for (const item of bodyItems) {
            if (!state.enabled) return;
            if (itemAnimEnabled && itemEnterEnabled) {
                await runAnim(item, itemEnter);
                if (itemAnimEnabled && itemExitEnabled) {
                    await runAnim(item, itemExit);
                }
            } else if (itemAnimEnabled && !itemEnterEnabled && itemExitEnabled) {
                await runAnim(item, itemExit);
            }
        }
    } else {
        for (const item of bodyItems) {
            if (!state.enabled) return;
            if (itemAnimEnabled && itemEnterEnabled) {
                await runAnim(item, itemEnter);
            }
        }

        const exitItems =
            itemProcessOrder === 'foldback' ? [...bodyItems].reverse() : [...bodyItems];
        if (itemAnimEnabled && itemExitEnabled) {
            for (const item of exitItems) {
                await runAnim(item, itemExit);
            }
        }
    }

    if (panelAnimEnabled && panelExitEnabled) {
        await runAnim(panel, panelExit);
    }
    debugPanelLayout(panel, `runPanel end index=${index}`);
    debugSequenceOverflow(root, `runPanel end overflow index=${index}`, panel);
    hidePanel(panel);
}

function setupControls(root, state, start) {
    const controls = qs(root, '.gpchild-animation-sequence__controls');
    if (!controls) return;
    const playPause = qs(controls, '[data-gpchild-control="playpause"]');
    const next = qs(controls, '[data-gpchild-control="next"]');
    controls.hidden = !(state.mode === 'manual-next' && state.showControls);
    if (!playPause || !next) return () => {};

    const onPlayPause = () => {
        state.paused = !state.paused;
        playPause.textContent = state.paused ? '再開' : '一時停止';
    };
    const onNext = () => {
        state.manualAdvance = true;
        if (!state.running) {
            start();
        }
    };
    playPause.addEventListener('click', onPlayPause);
    next.addEventListener('click', onNext);

    return () => {
        playPause.removeEventListener('click', onPlayPause);
        next.removeEventListener('click', onNext);
    };
}

function showFallback(root) {
    root.removeAttribute('data-gpchild-initial-transparent');
    var panels = qsa(root, '.wp-block-gpchild-animation-panel');
    panels.forEach(function (panel, i) {
        if (i === 0) {
            panel.hidden = false;
            panel.classList.add('is-active');
            qsa(panel, '.gpchild-animation-panel__inner > *').forEach(function (item) {
                item.style.removeProperty('opacity');
                item.style.removeProperty('animation');
                item.style.removeProperty('filter');
                item.style.removeProperty('clip-path');
                item.style.removeProperty('transform');
            });
            try { applyPanelTypographyScale(panel); } catch (_) {}
        }
    });
}

function boot(root) {
    _dbg('boot() 開始');
    const panels = qsa(root, '.wp-block-gpchild-animation-panel');
    _dbg('パネル数=' + panels.length);
    if (!panels.length) return;

    const state = {
        enabled: root.getAttribute('data-gpchild-enabled') === '1',
        mode: readString(root, 'mode', 'loop'),
        showControls: root.getAttribute('data-gpchild-show-controls') === '1',
        initialTransparent: root.getAttribute('data-gpchild-initial-transparent') === '1',
        panelDelayMs: readNumber(root, 'panel-delay-ms', 600),
        initialDelayMs: readNumber(root, 'initial-delay-ms', 0),
        paused: false,
        manualAdvance: false,
        running: false,
        initialDelayConsumed: false,
        destroyers: [],
    };
    _dbg('state: enabled=' + state.enabled + ' mode=' + state.mode + ' transparent=' + state.initialTransparent);
    _dbg(
        'env: version='
        + (root.getAttribute('data-gpchild-debug-version') || DEBUG_VERSION)
        + ' ua='
        + navigator.userAgent
        + ' innerWidth='
        + window.innerWidth
        + ' dpr='
        + window.devicePixelRatio
    );
    if (state.initialTransparent) {
        panels.forEach((panel) => {
            qsa(panel, '.gpchild-animation-panel__inner > *').forEach((item) => {
                item.style.opacity = '0';
                item.style.animation = 'none';
            });
        });
        _dbg('全アイテムをopacity:0, animation:noneに設定');
    }
    const teardownPanelScaling = setupPanelTypographyScaling(root);
    if (typeof teardownPanelScaling === 'function') {
        state.destroyers.push(teardownPanelScaling);
    }
    panels.forEach(applyPanelTypographyScale);
    panels.forEach(constrainVerticalWritingPanel);
    panels.forEach((panel) => hidePanel(panel));
    debugSequenceOverflow(root, 'boot-after-hide');
    _dbg('全パネルを非表示に設定完了');

    const start = async () => {
        _dbg('start() 呼出: enabled=' + state.enabled + ' running=' + state.running);
        if (!state.enabled || state.running) return;
        state.running = true;
        try {
            if (!state.initialDelayConsumed && state.initialDelayMs > 0) {
                _dbg('初期遅延待ち: ' + state.initialDelayMs + 'ms');
                await wait(state.initialDelayMs);
                state.initialDelayConsumed = true;
            }
            let index = 0;
            let loop = true;
            while (loop && state.enabled) {
                if (state.paused) {
                    await wait(100);
                    continue;
                }
                _dbg('▶ runPanel index=' + index);
                await runPanel(root, panels, state, index);
                _dbg('◀ runPanel index=' + index + ' 完了');
                index += 1;
                if (index >= panels.length) {
                    if (state.mode === 'once-stop') {
                        loop = false;
                    } else if (state.mode === 'manual-next') {
                        state.running = false;
                        state.manualAdvance = false;
                        return;
                    } else {
                        index = 0;
                    }
                }
                if (state.mode === 'manual-next' && !state.manualAdvance) {
                    state.running = false;
                    return;
                }
                if (state.panelDelayMs > 0) {
                    await wait(state.panelDelayMs);
                }
                state.manualAdvance = false;
            }
        } catch (e) {
            _dbg('❌ start()エラー: ' + e.message);
            showFallback(root);
        }
        state.running = false;
    };

    const teardownControls = setupControls(root, state, start);
    if (typeof teardownControls === 'function') {
        state.destroyers.push(teardownControls);
    }
    const destroy = () => {
        state.enabled = false;
        state.paused = false;
        state.manualAdvance = false;
        state.running = false;
        state.destroyers.forEach((fn) => {
            try {
                fn();
            } catch (_) {}
        });
        state.destroyers = [];
        panels.forEach((panel) => {
            hidePanel(panel);
            panel.style.removeProperty('opacity');
            panel.style.removeProperty('transform');
            panel.style.removeProperty('filter');
            panel.style.removeProperty('clip-path');
            panel.style.removeProperty('animation');
            qsa(panel, '.gpchild-animation-panel__inner > *').forEach((item) => {
                item.style.removeProperty('opacity');
                item.style.removeProperty('animation');
                item.style.removeProperty('filter');
                item.style.removeProperty('clip-path');
                item.style.removeProperty('transform');
            });
        });
        root.removeAttribute('data-gpchild-js-booted');
        delete root[INSTANCE_KEY];
    };
    root[INSTANCE_KEY] = { destroy };
    root.setAttribute('data-gpchild-js-booted', '1');
    _dbg('boot()完了 → start() 呼出');
    start();
}

function destroyRoot(root) {
    if (!root) return;
    const instance = root[INSTANCE_KEY];
    if (instance && typeof instance.destroy === 'function') {
        try {
            instance.destroy();
        } catch (_) {}
    }
    delete root[INSTANCE_KEY];
    root.removeAttribute('data-gpchild-js-booted');
}

function initAll(options = {}) {
    const reset = Boolean(options && options.reset);
    if (shouldEnableDebugUi()) {
        ensureDebugUi();
    }
    _dbg('📦 view.js initAll() 実行 readyState=' + document.readyState);
    const roots = document.querySelectorAll(SELECTOR);
    _dbg('対象ブロック数=' + roots.length);
    if (reset) {
        roots.forEach((root) => {
            destroyRoot(root);
        });
    }
    roots.forEach((root) => {
        if (root.getAttribute('data-gpchild-js-booted') === '1' && root[INSTANCE_KEY]) {
            return;
        }
        try {
            boot(root);
        } catch (e) {
            _dbg('❌ boot()エラー: ' + e.message);
            showFallback(root);
        }
    });
}

if (typeof window !== 'undefined') {
    window.gpchildInitAnimationSequence = function (options) {
        initAll(options || {});
    };
}

if (document.readyState === 'loading') {
    _dbg('view.js 読込: DOMContentLoaded待ち');
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    _dbg('view.js 読込: DOM準備済 → 即時実行');
    initAll();
}

setTimeout(function () {
    document.querySelectorAll(SELECTOR).forEach(function (root) {
        var activePanel = root.querySelector('.wp-block-gpchild-animation-panel.is-active:not([hidden])');
        if (activePanel) {
            var items = activePanel.querySelectorAll('.gpchild-animation-panel__inner > *');
            var anyVisible = false;
            for (var k = 0; k < items.length; k++) {
                if (parseFloat(getComputedStyle(items[k]).opacity) > 0.01) {
                    anyVisible = true;
                    break;
                }
            }
            if (anyVisible) return;
        }
        showFallback(root);
    });
}, 7000);
